export default __webpack_public_path__ + "static/media/google_logo_menu.a3c5032e.svg";